import React from 'react'
import Color from './Color';
import * as Util from '../util/Util'
import { Row, Col, Button, Icon, message } from 'antd'

const DIRECTIONS = ['top','right','bottom','left']

export const ColorSquare=props=>{
  return (
    <Row>
      <Col>
        <div
          className="mr-auto mb-2"
          style={{
            backgroundColor: props.value||'',
            width: '4em',
            height: '4em',
            border: '.2em solid white'
          }}
          onClick={props.onClick}
        />
        <p className="lead">{props.value}</p>
      </Col>
    </Row>
  )
}

export default class Random extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.setup = this.setup.bind(this)
  }
  componentDidMount() {
    this.setup()
  }
  setup() {
    const from = Util.randColor()
    const to = Util.randColor()
    const index = Math.floor(Math.random()*4)
    const direction = DIRECTIONS[index]
    this.setState({
      from:from,
      to:to,
      direction:direction,
      copied: false,
    })
  }
  css() {
    return `/* fallback */
background: ${this.state.from};

/* Chrome 10-25, Safari 5.1-6 */
background: -webkit-linear-gradient(to ${this.state.direction}, ${this.state.from}, ${this.state.to});

/* W3C, IE10/Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
background: linear-gradient(to ${this.state.direction}, ${this.state.from}, ${this.state.to});`
  }
  iconOf=direction=>{
    if (direction==='bottom') return 'down'
    if (direction==='top') return 'up'
    return direction
  }
  renderDirectionBtn=direction=>{
    if (typeof(direction)==='string'&&direction.length>0) {
      const icon = this.iconOf(direction)
      const ghost = direction!==this.state.direction
      return (
        <Button ghost={ghost} onClick={()=>{
          this.setState({direction})
        }}><Icon type={icon} /></Button>
      )
    }
    return null
  }
  luminance() {
    const {from,to} = this.state
    if (typeof(from)==='string'&&from.length>0) {
      if (typeof(to)==='string'&&to.length>0) {
        const a = new Color(from)
        const b = new Color(to)
        const la = a.luminance()
        const lb = b.luminance()
        if (la.isEqual(lb)) return la.toString()
        // TODO: determine which color to return based on what
        //return la.toString()
      }
    }
    return Color.black.toString()
  }
  inverse() {
    // TODO: determine how to inverse gradient color, and to change its alpha value
    return Color.black.alpha(.075).toString()
  }
  copyToClipboard=event=>{
    event.preventDefault()
    const css = this.css()
    const {onCopy} = this.props
    if (typeof(css)==='string'&&css.length>0) {
      const el = document.createElement('textarea')
      el.value = css
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      message.success(`CSS is copied`)
      this.setState({copied:true},()=>{
        if (typeof(onCopy)==='function') {
          onCopy(css)
        }
      })
    }
  }
  render() {
    const {copied} = this.state
    const from = this.state.from||''
    const to = this.state.to||''
    const direction = this.state.direction||''
    const color = this.luminance()
    //const inversed = this.inverse()
    const style = {
      background: `linear-gradient(to ${direction}, ${from}, ${to})`,
      width: '100%',
      //cursor: 'pointer',
      /*display: 'table-cell',*/
      verticalAign: 'middle',
      color,
    }
    return (
      <div className="main-content"
        style={style}
        //onClick={this.setup}
      >
        <h1 style={{color}} className="text-center">Randomize background gradient color</h1>

        <div className="text-center mb-3">
          <Button
            type="primary"
            size="large"
            className="drop-shadow"
            onClick={this.setup}
            >Randomize All!
          </Button>
        </div>

        <Row className="mb-3">
          <Col span={7}>
            <p className="lead">From</p>
            <ColorSquare
              value={this.state.from}
              onClick={()=>{
                this.setState({from:Util.randColor()})
              }}
            />
          </Col>
          <Col span={7}>
            <p className="lead">To</p>
            <ColorSquare value={this.state.to}
              onClick={()=>{
                this.setState({to:Util.randColor()})
              }}
            />
          </Col>
          <Col span={10}>
            <p className="lead">Direction</p>
            <div style={{width:140}}>
              <Row>
                <Col span={8}>
                  <div className="filler" />
                  {this.renderDirectionBtn('left')}
                </Col>
                <Col span={8}>
                  <div>
                    {this.renderDirectionBtn('top')}
                  </div>
                  <div className="filler" />
                  <div>
                    {this.renderDirectionBtn('bottom')}
                  </div>
                </Col>
                <Col span={8}>
                  <div className="filler" />
                  {this.renderDirectionBtn('right')}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <div className="mb-2">
              <Row>
                <Col span={8}>
                  <Button ghost={copied} onClick={this.copyToClipboard}><Icon type="copy" />Copy<Icon type="arrow-down" /></Button>
                </Col>
                <Col span={8}>
                  <h3 style={{color}} className="text-center">CSS</h3>
                </Col>
                <Col span={8}>
                </Col>
              </Row>
            </div>
            <div className="box-shadow" style={{
                padding: '.25rem 0 .25rem 1rem',
                borderRadius: '1em',
                backgroundColor: `rgba(${Util.randInt()}, ${Util.randInt()},${Util.randInt()},.075)`,
                //backgroundColor: inversed.toString(),
              }}>
              <pre style={{marginBottom:0}}><code style={{
                whiteSpace: 'pre-wrap',
              }}>{this.css()}</code></pre>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}
